/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// BSS custom fix cart page
if(typeof BSS_B2B !== 'undefined') {
  window.addEventListener('cart_changed', function () {
    const shopData = JSON.parse($('#bss-b2b-store-data').html())
    if(shopData) {
      setTimeout(() => {
        BSS_B2B.cart.fixer(shopData, false, false)
      }, 1000)
    }
})
}

